
/**
 * Названия шагов
 */
const stepText = (stepKey) => {
  let result = stepKey
  switch (stepKey) {
  case 'TenderInformation':
    result = 'TenderInformation'
    break
  case 'TenderFromPlan':
    result = 'Tenders.from-plan'
    break
  case 'TenderLots':
    result = 'AddLots'
    break
  case 'SelectLotsFromFramwork':
    result = 'ChooseLots'
    break
  case 'SpecifyTender':
    result = 'ChooseLots'
    break
  case 'TenderTerms':
    result = 'TermsOfHolding'
    break
  case 'ContactPerson':
    result = 'ContactPerson'
    break
  case 'TenderCriteria':
    result = 'NotPriceCriteria'
    break
  case 'TenderDocuments':
    result = 'Documents'
    break
  case 'TenderCommercialOffer':
    result = 'CommercialOffer'
    break
  case 'TenderMembers':
    result = 'Members'
    break
  case 'SelectMembersFromFramwork':
    result = 'Members'
    break
  case 'TenderCheck':
    result = 'CheckTender'
    break
  case 'YoucontrolStep':
    result = 'YCMarket'
    break
  }
  return result
}
/**
 * свойства и видимость шагов
 */
const defaultProps = (props) => {
  return {
    component: props.step,
    text: stepText(props.step),
    componentInfo: props.componentInfo,
    visible: props ? true : false,
    order: props.order,
    rules: props.rules
  }
}
const tenderFromPlanProps = (props) => {
  const result = defaultProps(props)
  result.visible = result.visible && props.isPlan
  return result
}
const tenderCriteriaProps = (props) => {
  const result = defaultProps(props)
  result.visible = result.visible && props.useCriteriaCards
  return result
}
const lotsForTendeProps = (props) => {
  const result = defaultProps(props)
  result.visible = result.visible && !props.createdByExternalApi
  return result
}
const selectMembersFromFramworkProps = (/*props*/) => {
  return false // нет у нас таких торгов
  /*const result = defaultProps(props)
  result.visible = result.visible && !props.isAuctioFromFrame && !props.isAuctionWithoutPublication
  return result*/
}
const selectTenderMembersProps = (props) => {
  const result = defaultProps(props)
  result.visible = result.visible && !props.isAuctionWithoutPublication
  return result
}
const tenderCommercialOfferProps = (props) => {
  const result = defaultProps(props)
  result.text = `${result.text}${props.isAuctionWithoutPublication ? '_notKP' : ''}`
  return result
}
const tenderTermsProps = (props) => {
  const result = defaultProps(props)
  result.visible = result.visible && !props.isAuctionWithoutPublication
  return result
}

/**
 * список шагов по каждому флоу
 */
const flouProps = {
  default: (props) => {
    return [
      tenderFromPlanProps({...props, step: 'TenderFromPlan', order: 10}),
      defaultProps({...props, step: 'TenderInformation', order: 20}),
      lotsForTendeProps({...props, step: 'TenderLots', order: 30}),
      selectMembersFromFramworkProps({...props, step: 'SelectLotsFromFramwork', order: 40}),
      defaultProps({...props, step: 'SpecifyTender', order: 50}),
      tenderTermsProps({...props, step: 'TenderTerms', order: 60}),
      defaultProps({...props, step: 'ContactPerson', order: 70}),
      tenderCriteriaProps({...props, step: 'TenderCriteria', order: 80}),
      defaultProps({...props, step: 'TenderDocuments', order: 90}),
      tenderCommercialOfferProps({...props, step: 'TenderCommercialOffer', order: 100}),
      defaultProps({...props, step: 'TenderMembers', order: 110}),
      selectMembersFromFramworkProps({...props, step: 'SelectMembersFromFramwork', order: 120}),
      defaultProps({...props, step: 'TenderCheck', order: 130}),
    ]
  },
  fast: (props) => {
    return [
      defaultProps({...props, step: 'TenderInformation', order: 10}),
      lotsForTendeProps({...props, step: 'TenderLots', order: 20}),
      defaultProps({...props, step: 'SpecifyTender', order: 30}),
      defaultProps({...props, step: 'TenderTerms', order: 40}),
      defaultProps({...props, step: 'TenderCheck', order: 50}),
    ]
  },
  youcontrol: (props) => {
    const defaultTemplateProps = flouProps.default(props)

    defaultTemplateProps.push(
      defaultProps({...props, step: 'YoucontrolStep', order: 9})
    )
    return defaultTemplateProps
  },
  newDesignDefault_default: (props) => {
    return [
      defaultProps({...props, step: 'TenderInformation', order: 10, rules: ['TenderInformation']}),
      defaultProps({...props, step: 'TenderLots', order: 20, rules: ['TenderInformation', 'TenderLots']}),
      tenderCriteriaProps({...props, step: 'TenderCriteria', order: 40, rules: ['TenderInformation', 'TenderCriteria', 'TenderLots']}),
      tenderCommercialOfferProps({...props, step: 'TenderCommercialDocumentAndOffer', order: 50, rules: ['TenderInformation', 'TenderCriteria', 'TenderLots', 'TenderCommercialOffer']}),
      selectTenderMembersProps({...props, step: 'TenderMembers', componentInfo: 'TenderMembersInfo', order: 60, rules: ['TenderInformation', 'TenderCriteria', 'TenderLots', 'TenderCommercialOffer', 'TenderMembers']}),
      defaultProps({...props, step: 'TenderCheck', componentInfo: 'TenderInfoPanel', order: 70, rules: ['TenderInformation', 'TenderLots', 'TenderCriteria', 'TenderCommercialOffer', 'TenderMembers', 'TenderCheck']}),
    ]
  },
  newDesignDefault_youcontrol: (props) => {
    return [
      defaultProps({...props, step: 'YoucontrolStep', order: 10, rules: []}),
      defaultProps({...props, step: 'TenderInformation', order: 10, rules: ['TenderInformation']}),
      defaultProps({...props, step: 'TenderLots', order: 20, rules: ['TenderInformation', 'TenderLots']}),
      tenderCriteriaProps({...props, step: 'TenderCriteria', order: 40, rules: ['TenderInformation', 'TenderCriteria', 'TenderLots']}),
      tenderCommercialOfferProps({...props, step: 'TenderCommercialDocumentAndOffer', order: 50, rules: ['TenderInformation', 'TenderCriteria', 'TenderLots', 'TenderCommercialOffer']}),
      selectTenderMembersProps({...props, step: 'TenderMembers', componentInfo: 'TenderMembersInfo', order: 60, rules: ['TenderInformation', 'TenderCriteria', 'TenderLots', 'TenderCommercialOffer', 'TenderMembers']}),
      defaultProps({...props, step: 'TenderCheck', componentInfo: 'TenderInfoPanel', order: 70, rules: ['TenderInformation', 'TenderLots', 'TenderCriteria', 'TenderCommercialOffer', 'TenderMembers', 'TenderCheck']}),
    ]
  },
}

export default flouProps
